import React from 'react';
import { PageTitle } from '@cordata/buffet';

import Form from '~/components/DivisionLogo/Form';

const DivisionLogosAdd = () => (
  <>
    <PageTitle>Add Division Logo</PageTitle>

    <Form data={{}} />
  </>
);

export default DivisionLogosAdd;
